import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

type EmptyStateProps = {
	icon?: LucideIcon;
	/** Monospace tag above the title, e.g. `WORKSTREAM A` or `00 PROJECTS`. */
	tag?: string;
	title: string;
	description?: React.ReactNode;
	action?: React.ReactNode;
	className?: string;
};

/** Blueprint-styled empty/placeholder panel: dot-grid field, crop marks, centered copy. */
export function EmptyState({
	icon: Icon,
	tag,
	title,
	description,
	action,
	className,
}: EmptyStateProps) {
	return (
		<div
			className={cn(
				"crop-marks relative flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed px-6 py-16 text-center",
				className,
			)}
		>
			<div className="bg-dot-grid pointer-events-none absolute inset-0 rounded-lg opacity-60 [mask-image:radial-gradient(ellipse_at_center,black_20%,transparent_70%)]" />
			{Icon && (
				<div className="relative flex size-10 items-center justify-center rounded-lg border bg-card shadow-xs">
					<Icon className="size-5 text-muted-foreground" />
				</div>
			)}
			<div className="relative flex max-w-sm flex-col items-center gap-1.5">
				{tag && <span className="mono-label">{tag}</span>}
				<h3 className="text-[15px] font-medium">{title}</h3>
				{description && <p className="text-[13px] text-muted-foreground">{description}</p>}
			</div>
			{action && <div className="relative mt-1">{action}</div>}
		</div>
	);
}
